"use client";
import Images from "@/app/assets/assets";
import React from "react";
import Image from "next/image";
export type TextSlide = {
  year: number;
  title: string;
  body: string;
};

type TextSlidesProps = {
  slides: TextSlide[];
  activeIndex: number;
};

export default function TextSlides({ slides, activeIndex }: TextSlidesProps) {
  return (
    <div
      className="absolute hidden 2xl:block right-8 md:right-[550px] top-[calc(100vh_-_500px)] max-w-xl"
      id="textSlides"
    >
      {slides?.map((s, idx) => (
        <div
          key={s.year}
          className={`fade-slide absolute w-[450px] h-[max-content] inset-0 ${idx === activeIndex ? "opacity-100" : "opacity-0"}`}
        >
          <div className="relative w-full">
            <Image
              src={Images?.jurney_arrow}
              alt="jurney arrow"
              width={136}
              height={100}
              className="w-[136px] block ml-auto"
              sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
              priority
              fetchPriority="high"
            />
            <p className="mt-3 text-white/70">{s.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
